import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProjectService, Project } from '../services/project.service';
import { SelectedProjectService } from '../services/selectedproject.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-project',
  imports: [CommonModule, FormsModule, RouterModule, MatIconModule, MatTooltipModule],
  templateUrl: './project.component.html',
  styleUrl: './project.component.css'
})
export class ProjectComponent {
  projects: Project[] = [];
  loading = false;
  error: string | null = null;
  selectedProjectNumber: number | null = null;
  company: string | null = null;
  searchTerm = '';

  constructor(private projectService: ProjectService, private selectedProjectService: SelectedProjectService, private authService: AuthService) {}

  ngOnInit() {
    this.fetchAllProjects();
    this.selectedProjectNumber = this.selectedProjectService.getSelectedProject();
    this.company = this.authService.getCompany();
  }

  fetchAllProjects() {
    this.loading = true;
    this.error = null;

    this.projectService.getAllProjects().subscribe({
      next: (data) => {
        this.projects = data;
        this.loading = false;
      },
      error: (err) => {
        this.error = typeof err.error === 'string' ? err.error : 'Error fetching projects.';
        this.loading = false;
      },
    });
  }

  get filteredProjects(): Project[] {
    if (!this.searchTerm.trim()) return this.projects;
    const term = this.searchTerm.toLowerCase();
    return this.projects.filter(p =>
      p.projectNumber.toString().includes(term) ||
      p.projectName.toLowerCase().includes(term) ||
      p.pm.toLowerCase().includes(term) ||
      (p.outsourcePm?.toLowerCase().includes(term) ?? false)
    );
  }

  selectProject(projectNumber: number) {
    if (this.selectedProjectNumber === projectNumber) {
      this.selectedProjectNumber = null;
      this.selectedProjectService.clearSelectedProject();
    } else {
      this.selectedProjectNumber = projectNumber;
      this.selectedProjectService.setSelectedProject(projectNumber);
    }
  }

  canCreateProject(): boolean {
    return !this.authService.isReadOnly() && this.authService.hasAnyRole(['Admin']);
  }
}
